// 检查是否为安卓环境
export const isAndroidEnv = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('android');
};

/**
 * 动态加载外部脚本
 * @param options.src - 脚本 URL
 * @param options.scriptId - 脚本标识 (设置到 data-sdk 属性)
 * @param options.async - 是否异步加载
 * @param options.crossOrigin - 跨域策略
 * @param options.dataAttributes - 自定义 data-* 属性
 * @returns Promise (加载失败仅警告, 不 reject)
 */
export const loadScript = (options: {
    src: string;
    scriptId: string;
    async?: boolean;
    crossOrigin?: 'anonymous' | 'use-credentials';
    dataAttributes?: Record<`data-${string}`, string>;
}): Promise<void> => {
    const script = document.createElement('script');

    // 设置基本属性
    script.src = options.src;
    if (options.async) script.async = true;
    if (options.crossOrigin) script.crossOrigin = options.crossOrigin;

    // 设置 data-sdk 属性作为标识
    script.setAttribute('data-sdk', options.scriptId);

    // 设置其他自定义属性
    if (options.dataAttributes) {
        Object.entries(options.dataAttributes).forEach(([key, value]) => {
            script.setAttribute(key, value);
        });
    }

    // 失败时仅警告, 不 reject
    return new Promise((resolve) => {
        script.addEventListener('load', () => resolve());

        script.addEventListener('error', () => {
            console.warn(
                `[loadScript]: Failed to load script '${options.src}' (data-sdk: '${options.scriptId}')`,
            );
            resolve();
        });

        document.head.appendChild(script);
    });
};
